export const UTM_PARAMS = 'UTM_PARAMS';

export const FIRST_VISIT_COOKIE = 'first_visit_logged';
